import { useState } from "react";
import AdminCard from "./AdminCard";

interface Props { onSave: () => void; }

export default function AdminContact({ onSave }: Props) {
  const [form, setForm] = useState({
    address: "One Embankment",
    city: "Leeds LS1 4DW, United Kingdom",
    phoneUK: "+44 20 3097 6185",
    phoneIntl: "+1 437 292 2296",
    email: "invest@thorpedellow.com",
    officeHours: "Mon–Fri: 9am–5pm",
    officeHoursSub: "Excluding UK Bank Holidays",
    portalUrl: "https://portal.thorpedellow.com",
    linkedinUrl: "#",
    twitterUrl: "#",
    mapEmbedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2353.0!2d-1.5491!3d53.7997!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48795c2a6c0fc0e5%3A0x0!2sOne+Embankment%2C+Leeds+LS1+4DW!5e0!3m2!1sen!2suk!4v1711000000002",
    responseTime: "Response within 24 hours",
    companyNumber: "07590563",
    companyName: "Thorpe Property Development Ltd",
    tradingAs: "Thorpe Dellow",
  });

  const update = (k: string, v: string) => setForm((f) => ({ ...f, [k]: v }));

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-[#071A2E]" style={{ fontFamily: "'Playfair Display', serif" }}>Contact Information</h1>
        <p className="text-slate-500 text-sm mt-1">Update office address, phone numbers, email, social links, and map embed.</p>
      </div>

      <AdminCard title="Office Address">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label className="block text-xs font-semibold text-slate-600 mb-1.5">Street Address</label>
            <input value={form.address} onChange={(e) => update("address", e.target.value)} className="w-full border border-slate-200 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:border-[#C9A84C]" />
          </div>
          <div>
            <label className="block text-xs font-semibold text-slate-600 mb-1.5">City, Postcode, Country</label>
            <input value={form.city} onChange={(e) => update("city", e.target.value)} className="w-full border border-slate-200 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:border-[#C9A84C]" />
          </div>
        </div>
      </AdminCard>

      <AdminCard title="Phone Numbers">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label className="block text-xs font-semibold text-slate-600 mb-1.5">UK Phone</label>
            <input value={form.phoneUK} onChange={(e) => update("phoneUK", e.target.value)} className="w-full border border-slate-200 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:border-[#C9A84C]" />
          </div>
          <div>
            <label className="block text-xs font-semibold text-slate-600 mb-1.5">International Phone</label>
            <input value={form.phoneIntl} onChange={(e) => update("phoneIntl", e.target.value)} className="w-full border border-slate-200 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:border-[#C9A84C]" />
          </div>
        </div>
      </AdminCard>

      <AdminCard title="Email & Hours">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label className="block text-xs font-semibold text-slate-600 mb-1.5">Investment Email</label>
            <input type="email" value={form.email} onChange={(e) => update("email", e.target.value)} className="w-full border border-slate-200 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:border-[#C9A84C]" />
          </div>
          <div>
            <label className="block text-xs font-semibold text-slate-600 mb-1.5">Response Time Note</label>
            <input value={form.responseTime} onChange={(e) => update("responseTime", e.target.value)} className="w-full border border-slate-200 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:border-[#C9A84C]" />
          </div>
          <div>
            <label className="block text-xs font-semibold text-slate-600 mb-1.5">Office Hours</label>
            <input value={form.officeHours} onChange={(e) => update("officeHours", e.target.value)} className="w-full border border-slate-200 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:border-[#C9A84C]" />
          </div>
          <div>
            <label className="block text-xs font-semibold text-slate-600 mb-1.5">Office Hours Sub-note</label>
            <input value={form.officeHoursSub} onChange={(e) => update("officeHoursSub", e.target.value)} className="w-full border border-slate-200 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:border-[#C9A84C]" />
          </div>
        </div>
      </AdminCard>

      <AdminCard title="Links & Social">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label className="block text-xs font-semibold text-slate-600 mb-1.5">Client Portal URL</label>
            <input value={form.portalUrl} onChange={(e) => update("portalUrl", e.target.value)} className="w-full border border-slate-200 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:border-[#C9A84C]" />
          </div>
          <div>
            <label className="block text-xs font-semibold text-slate-600 mb-1.5">LinkedIn URL</label>
            <input value={form.linkedinUrl} onChange={(e) => update("linkedinUrl", e.target.value)} className="w-full border border-slate-200 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:border-[#C9A84C]" />
          </div>
          <div>
            <label className="block text-xs font-semibold text-slate-600 mb-1.5">Twitter / X URL</label>
            <input value={form.twitterUrl} onChange={(e) => update("twitterUrl", e.target.value)} className="w-full border border-slate-200 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:border-[#C9A84C]" />
          </div>
        </div>
      </AdminCard>

      <AdminCard title="Google Maps Embed">
        <div>
          <label className="block text-xs font-semibold text-slate-600 mb-1.5">Map Embed URL (from Google Maps &gt; Share &gt; Embed)</label>
          <textarea value={form.mapEmbedUrl} onChange={(e) => update("mapEmbedUrl", e.target.value)} rows={3} className="w-full border border-slate-200 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:border-[#C9A84C] resize-none font-mono" />
          <p className="text-xs text-slate-400 mt-1.5">Paste the src URL from the Google Maps embed iframe code.</p>
        </div>
        {form.mapEmbedUrl && (
          <div className="mt-4 w-full h-40 rounded-xl overflow-hidden border border-slate-200">
            <iframe src={form.mapEmbedUrl} width="100%" height="100%" style={{ border: 0 }} allowFullScreen loading="lazy" title="Map Preview" />
          </div>
        )}
      </AdminCard>

      <AdminCard title="Company Registration">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          <div>
            <label className="block text-xs font-semibold text-slate-600 mb-1.5">Company Name</label>
            <input value={form.companyName} onChange={(e) => update("companyName", e.target.value)} className="w-full border border-slate-200 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:border-[#C9A84C]" />
          </div>
          <div>
            <label className="block text-xs font-semibold text-slate-600 mb-1.5">Trading As</label>
            <input value={form.tradingAs} onChange={(e) => update("tradingAs", e.target.value)} className="w-full border border-slate-200 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:border-[#C9A84C]" />
          </div>
          <div>
            <label className="block text-xs font-semibold text-slate-600 mb-1.5">Company Number</label>
            <input value={form.companyNumber} onChange={(e) => update("companyNumber", e.target.value)} className="w-full border border-slate-200 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:border-[#C9A84C]" />
          </div>
        </div>
      </AdminCard>

      <div className="flex justify-end">
        <button onClick={onSave} className="flex items-center gap-2 px-6 py-3 rounded-xl bg-[#071A2E] text-white text-sm font-semibold hover:bg-[#0D2B4A] transition-colors cursor-pointer whitespace-nowrap">
          <i className="ri-save-line leading-none" />
          Save Changes
        </button>
      </div>
    </div>
  );
}
